var $ = require('jquery');
var maskLayer = require('./mask-layer');
var Util = require('../core/util');
var path = require('../core/_path')();
var imgPath = Util.normalizeUrlPath(path + '../img/');
var loadingImgPath = imgPath+'loading/';

var iconMap = {
    '0':'<img height="24" src="' +loadingImgPath+'0.gif'+'">',
    '1':'<img height="37" src="' +loadingImgPath+'1.gif'+'">',
    '2':'<img height="32" src="' +loadingImgPath+'2.gif'+'">'
};
var _singleton = maskLayer();

function transformIcon(icon) {
    icon +='';
    if(iconMap[icon]){
        icon = iconMap[icon];
    }else if(icon.indexOf('fa-')===0){
        icon = '<i class="fa ' +icon+'"></i>';
    }
    return icon;
}

/**
 * loading
 * @param {string} content loading的文字
 * @param {object=} options 配置项
 * @param {string=} options.className 自定义类名
 *
 * @example
 * var loading = trf.loading('loading', {
 *     className: 'custom-classname'
 * });
 * setTimeout(function () {
 *     loading.hide(function() {
 *          console.log('`loading` has been hidden');
 *      });
 * }, 3000);
 */
function loading(content, options) {
    var hideFlag = false;
    var maskContent = '';
    var defaultOptions = {
        content: content||'',
        //可传font-awesome，例：'fa-spinner fa-spin'|'fa-circle-o-notch fa-spin'|'fa-refresh fa-spin'|'fa-cog fa-spin'
        icon:'fa-cog fa-spin',
        className: ''
    };
    options = $.extend(defaultOptions, options);

    if(options.icon){
        maskContent +=  '<div class="icon">' +transformIcon(options.icon)+'</div>'
    }
    if(options.content){
        maskContent +=  '<div class="content">' +options.content+'</div>'
    }

    _singleton.getMaskLayer().removeClass().addClass('loading '+options.className);
    _singleton.getMaskContent().toggleClass('is-icon',!!options.icon).html(maskContent);
    _singleton.show();

    return {
        hide:function (callback) {
            if(!hideFlag){
                _singleton.hide(callback);
                hideFlag = true;
            }else {
                console.log('loading warning: hide方法至多调用一次有效');
            }
        }
    };
}
module.exports = loading;



//////////////////
// WEBPACK FOOTER
// ./src/components/loading.js
// module id = 79
// module chunks = 0